<template lang='pug'>
//- 線上諮詢語音輸入
div(:class='$style[`cc-popbox-speech-uploader`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div.prevent-selection(:class='$style[`cc-content-title`]')
    span.font-bold(:class='$style[`cc-banner-main-title`]')
      span.prevent-selection.no-wrap 語音輸入訊息
      //- span.font-normal-theme 輸入

    //- span.font-bold(:class='$style[`cc-banner-main-subtitle`]') 按住麥克風圖示，開始講話

  div(:class='$style[`cc-uploader-content`]')
    //- div(v-if='newSpeech.isFinal' :class='$style[`cc-uploader-area`]')
    //-   span {{ newSpeech.result }}

    div(ref="tracker" :class='$style[`cc-uploader-area`]')
      div(:class='[$style[`cc-uploader-speech`], $style[newSpeech.isListening ? `isRecording` : ``]]')
        div(:class='$style[`cc-uploader-speech-icon`]')
          IconMic(:size='50' :color='`#262626`')
    div.prevent-selection(v-if='newSpeech.result' :class='$style[`cc-uploader-speech-result`]')
      span.prevent-selection.font-bold {{ newSpeech.result }}
    div.prevent-selection(v-else :class='$style[`cc-uploader-speech-tips`]')
      span.prevent-selection.font-bold 按住麥克風圖示，開始講話


  div(v-if='!newSpeech.isListening && newSpeech.result' :class='$style[`cc-content-controller`]')
    button.btn-confirm-extra(
      title='完成輸入'
      tabindex='0'
      aria-label='完成輸入'
      :class='$style[`cc-controller-send`]'
      @click='debounceSendSpeechResult') 完成輸入

  //- div(v-else-if='!newSpeech.isListening && !newSpeech.isFinal && !newSpeech.result' :class='$style[`cc-content-controller`]')
  //-   button.btn-black-extra(
  //-     title='取消'
  //-     tabindex='0'
  //-     aria-label='取消'
  //-     :class='$style[`cc-controller-cancel`]'
  //-     @click='sendSpeechMessage') 取消

</template>

<script>
// import { ref } from "@vue/composition-api"
import { mapMutations } from 'vuex';
import { useMousePressed, useSpeechRecognition } from '@vueuse/core'
// const {
//   isSupported, isListening, isFinal, result, start, stop
// } = useSpeechRecognition({
//   lang: 'cmn-Hant-TW',
//   interimResults: true,
//   continuous: true,
// });

import GlobalEmitter from 'tiny-emitter/instance';
import IconMic from '../../icon/Mic';
import Inputer from '../common/Input';
import { debounce } from 'debounce';

export default {
  components: {
    IconMic,
    Inputer,
  },

  props: {
    room: {
      type: String,
      default: '',
    },
  },

  created() {
    document.body.classList.add('prevent-selection');
  },

  destroyed() {
    document.body.classList.remove('prevent-selection');
  },

  mounted() {
    this.newPressed = useMousePressed({ target: this.$refs['tracker'] });
  },

  data() {
    return {
      newPressed: null,
      newSpeech: useSpeechRecognition({
        lang: 'cmn-Hant-TW',
        interimResults: true,
        continuous: true,
      }),
    };
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
    }),

    handleClosePopBox() {
      this.changePopBoxStatus({
        active: false,
        include: '',
      });
    },

    sendSpeechMessage() {
      GlobalEmitter.emit('create-speech', {
        speech: this.newSpeech.result,
      });
      this.handleClosePopBox();
    },

    debounceSendSpeechResult: debounce(async function(e) {
      this.sendSpeechMessage(e);
    }, 300),
  },

  // eslint-disable-next-line vue/order-in-components
  // computed: {
  //   ...mapGetters({
  //     loginProfile: 'user/exportUserProfile',
  //     loginDjangoId: 'user/exportUserDjangoId',
  //     loginHashCode: 'user/exportUserHashCode',
  //     authJwtToken: 'user/exportUserJwtToken',
  //     consultWebSocket: 'user/exportConsultWebSocket',
  //   }),
  // },

  watch: {
    'newPressed.pressed': function (val) {
      val ? this.newSpeech.start() : this.newSpeech.stop();
    },
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popSpeechInputer.scss';
</style>
